import React from 'react';

function MobilePopup({ isOpen, onClose, title, children, fullScreen = false }) {
  if (!isOpen) return null;

  const isMobile = window.innerWidth <= 768;

  return (
    <div 
      className="mobile-popup"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.8)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: isMobile ? '10px' : '20px',
        animation: 'fadeIn 0.3s ease-out'
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div 
        className={`mobile-popup-content ${fullScreen ? 'timetable-fullscreen' : ''}`}
        style={{
          background: 'white',
          borderRadius: fullScreen ? 0 : (isMobile ? '12px' : '16px'),
          width: fullScreen ? '100vw' : '100%',
          maxWidth: fullScreen ? '100vw' : (isMobile ? '95vw' : '900px'),
          maxHeight: fullScreen ? '100vh' : (isMobile ? '90vh' : '85vh'),
          overflowY: 'auto',
          position: 'relative',
          padding: fullScreen ? 0 : (isMobile ? '20px' : '30px'),
          animation: 'popupSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
          boxShadow: fullScreen ? 'none' : '0 20px 60px rgba(0,0,0,0.3)',
          margin: fullScreen ? 0 : 'auto'
        }}
      >
        <button
          className="mobile-popup-close"
          onClick={onClose}
          style={{
            background: '#dc2626',
            color: 'white',
            border: 'none',
            width: fullScreen ? '45px' : (isMobile ? '35px' : '40px'),
            height: fullScreen ? '45px' : (isMobile ? '35px' : '40px'),
            borderRadius: '50%',
            fontSize: fullScreen ? '20px' : (isMobile ? '18px' : '20px'),
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.3s ease',
            position: fullScreen ? 'fixed' : 'absolute',
            top: fullScreen ? '20px' : (isMobile ? '15px' : '20px'),
            right: fullScreen ? '20px' : (isMobile ? '15px' : '20px'),
            zIndex: fullScreen ? 1000 : 10,
            background: fullScreen ? 'rgba(0, 0, 0, 0.7)' : '#dc2626',
            backdropFilter: fullScreen ? 'blur(10px)' : 'none',
            border: fullScreen ? '2px solid rgba(255, 255, 255, 0.2)' : 'none'
          }}
          onMouseEnter={(e) => {
            e.target.style.background = fullScreen ? 'rgba(0, 0, 0, 0.9)' : '#b91c1c';
            e.target.style.transform = 'scale(1.1)';
          }}
          onMouseLeave={(e) => {
            e.target.style.background = fullScreen ? 'rgba(0, 0, 0, 0.7)' : '#dc2626';
            e.target.style.transform = 'scale(1)';
          }}
        >
          ✕
        </button>

        {!fullScreen && title && (
          <div 
            className="mobile-popup-header"
            style={{
              paddingBottom: '15px',
              borderBottom: '2px solid #e5e7eb',
              marginBottom: '20px'
            }}
          >
            <h3 style={{
              fontSize: isMobile ? '20px' : '24px',
              fontWeight: '700',
              color: '#1f2937',
              margin: 0
            }}>
              {title}
            </h3>
          </div>
        )}

        <div style={{ 
          paddingTop: fullScreen ? '60px' : '0',
          height: fullScreen ? '100%' : 'auto'
        }}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default MobilePopup;